import indexConfig from "@/config/index.js";
import Vue from "vue";
import store from "@/store";

describe("index config", () => {
  beforeEach(() => {
    jest.spyOn(indexConfig, "install");
    jest.spyOn(indexConfig, "start");
    jest.spyOn(indexConfig, "get");
    jest.spyOn(indexConfig, "getPasoProperties");
  });

  it("testing function called ", () => {
    indexConfig.install(Vue);
    indexConfig.start(jest.fn());
    indexConfig.get();
    indexConfig.getPasoProperties();
    const installFunction = jest.spyOn(indexConfig, "install");
    const startFunction = jest.spyOn(indexConfig, "start");
    const getFunction = jest.spyOn(indexConfig, "get");
    const getPasoPropertiesFunction = jest.spyOn(
      indexConfig,
      "getPasoProperties"
    );

    expect(installFunction).toHaveBeenCalled();
    expect(startFunction).toHaveBeenCalled();
    expect(getFunction).toHaveBeenCalled();
    expect(getPasoPropertiesFunction).toHaveBeenCalled();
  });

  it("testing function catch ", () => {
    indexConfig.install(Vue);
    indexConfig.start(jest.fn());
    indexConfig.get();
    indexConfig.getPasoProperties();
    const installFunction = jest.spyOn(indexConfig, "install");
    const startFunction = jest.spyOn(indexConfig, "start");
    const getFunction = jest.spyOn(indexConfig, "get");
    const getPasoPropertiesFunction = jest.spyOn(
      indexConfig,
      "getPasoProperties"
    );

    store.dispatch = jest.fn().mockImplementation(() => {
      throw new Error("Error");
    });
    indexConfig.install(Vue);
    expect(installFunction).toHaveBeenCalled();
    expect(startFunction).toHaveBeenCalled();
    expect(getFunction).toHaveBeenCalled();
    expect(getPasoPropertiesFunction).toHaveBeenCalled();
  });
});
